export interface AuthorizedAccount {
  examineeId: string;
  examineeNumber: string;
  officeCode: string;
  officeName: string;
  hasUnreadAnswer: boolean;
  hasUserInquiry: boolean;
  hasCompletion: boolean;
  isReadonly: boolean;
  isFastForwarding: boolean;
}

export const EmptyAuthorizedAccount: AuthorizedAccount = {
  examineeId: '',
  examineeNumber: '',
  officeCode: '',
  officeName: '',
  hasUnreadAnswer: false,
  hasUserInquiry: false,
  hasCompletion: false,
  isReadonly: false,
  isFastForwarding: false,
};
